import { FC, HtmlHTMLAttributes } from 'react';
import styled from '@emotion/styled';
const ModalFooterLayout = styled.div<{
  isWebview: boolean;
}>`
  padding: 16px 24px ${({
  isWebview
}) => isWebview ? '16px' : '24px'} 24px;
  max-width: 100%;
  position: relative;
  border-top: 1px solid transparent;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
  display: flex;
  flex-direction: column;
`;
const ModalFooter: FC<HtmlHTMLAttributes<HTMLDivElement>> = ({
  children,
  ...props
}) => {
  return <ModalFooterLayout {...props} isWebview={!!window.AzarJs} data-sentry-element="ModalFooterLayout" data-sentry-component="ModalFooter" data-sentry-source-file="ModalFooter.tsx">
      {children}
    </ModalFooterLayout>;
};
export default ModalFooter;